import * as React from 'react';
import { Container } from 'reactstrap';

export interface IPriceTableProps {
    image_path: string;
    image: string;
    title: string;
    url: string;
}

export const PriceTable = (props: IPriceTableProps) => (
    <Container className='d-flex justify-content-center align-items-start' style={{ padding: '20px' }}>
        <a href={props.url} target='_blank'>
            <img src={props.image_path + props.image} style={{ width: '100%', maxWidth: 1000 }} title={props.title} />
        </a>
    </Container>
);


// WEBPACK FOOTER //
// ./src/pages/Home/PriceTable/index.tsx